var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdvantages7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 69,
    viewBox: "0 0 67 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1992_30696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.11 0.476074H13.5833C8.41028 0.476074 4.20166 4.74751 4.20166 9.99777V55.9558C4.20166 61.2061 8.41028 65.4775 13.5833 65.4775H51.11C56.2831 65.4775 60.4917 61.2061 60.4917 55.9558V9.99777C60.4917 4.74751 56.2831 0.476074 51.11 0.476074ZM56.739 55.9558C56.739 59.106 54.2138 61.6688 51.11 61.6688H13.5833C10.4795 61.6688 7.95433 59.106 7.95433 55.9558V9.99777C7.95433 6.84761 10.4795 4.28475 13.5833 4.28475H51.11C54.2138 4.28475 56.739 6.84761 56.739 9.99777V55.9558Z",
    fill: "#58A291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.11 13.4255H13.5834C12.5471 13.4255 11.707 14.2782 11.707 15.3299V25.4863C11.707 26.5381 12.5471 27.3907 13.5834 27.3907H51.11C52.1463 27.3907 52.9864 26.5381 52.9864 25.4863V15.3299C52.9864 14.2782 52.1463 13.4255 51.11 13.4255ZM49.2337 23.582H15.4597V17.2342H49.2337V23.582Z",
    fill: "#58A291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0887 31.1995H13.5834C12.5471 31.1995 11.707 32.0521 11.707 33.1038V40.7212C11.707 41.7729 12.5471 42.6255 13.5834 42.6255H21.0887C22.1249 42.6255 22.965 41.7729 22.965 40.7212V33.1038C22.965 32.0521 22.1249 31.1995 21.0887 31.1995ZM19.2124 38.8168H15.4597V35.0081H19.2124V38.8168Z",
    fill: "#58A291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0887 46.4341H13.5834C12.5471 46.4341 11.707 47.2867 11.707 48.3384V55.9558C11.707 57.0075 12.5471 57.8601 13.5834 57.8601H21.0887C22.1249 57.8601 22.965 57.0075 22.965 55.9558V48.3384C22.965 47.2867 22.1249 46.4341 21.0887 46.4341ZM19.2124 54.0514H15.4597V50.2428H19.2124V54.0514Z",
    fill: "#58A291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1102 31.1995H43.6048C42.5686 31.1995 41.7285 32.0521 41.7285 33.1038V55.9559C41.7285 57.0076 42.5686 57.8602 43.6048 57.8602H51.1102C52.1464 57.8602 52.9865 57.0076 52.9865 55.9559V33.1038C52.9865 32.0521 52.1464 31.1995 51.1102 31.1995ZM49.2338 54.0515H45.4812V35.0081H49.2338V54.0515Z",
    fill: "#58A291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0994 31.1995H28.5941C27.5579 31.1995 26.7178 32.0521 26.7178 33.1038V40.7212C26.7178 41.7729 27.5579 42.6255 28.5941 42.6255H36.0994C37.1357 42.6255 37.9758 41.7729 37.9758 40.7212V33.1038C37.9758 32.0521 37.1357 31.1995 36.0994 31.1995ZM34.2231 38.8168H30.4704V35.0081H34.2231V38.8168Z",
    fill: "#58A291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0994 46.4341H28.5941C27.5579 46.4341 26.7178 47.2867 26.7178 48.3384V55.9558C26.7178 57.0075 27.5579 57.8601 28.5941 57.8601H36.0994C37.1357 57.8601 37.9758 57.0075 37.9758 55.9558V48.3384C37.9758 47.2867 37.1357 46.4341 36.0994 46.4341ZM34.2231 54.0514H30.4704V50.2428H34.2231V54.0514Z",
    fill: "#58A291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5941 10.7595H36.0994C37.1357 10.7595 37.9758 9.90685 37.9758 8.85514C37.9758 7.80344 37.1357 6.95081 36.0994 6.95081H28.5941C27.5579 6.95081 26.7178 7.80344 26.7178 8.85514C26.7178 9.90685 27.5579 10.7595 28.5941 10.7595Z",
    fill: "#58A291"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1992_30696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 68,
    fill: "white",
    transform: "translate(0 0.476074)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdvantages7);
export default __webpack_public_path__ + "static/media/icon-advantages-7.8a777b4448726722ebf63c314e845ac9.svg";
export { ForwardRef as ReactComponent };